import _forEach from 'lodash/forEach'
import { Map, List } from 'immutable'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'
import 'rxjs/add/observable/empty'
import 'rxjs/add/observable/dom/ajax'
import 'rxjs/add/operator/skipWhile'
import * as MessageActions from 'app/modules/message/actions'
import {
  FETCH_CARD,
} from './constants'
import {
  fetchCard,
  fetchCardSuccess,
  fetchCardFailure,
  updateHrefs,
} from './actions'
import * as cardApi from './api'
import {
  getHrefsByMessageId,
  getCardsByHref,
} from './selectors'

function extractLinks(action$, { getState }) {
  const message$ = action$
    .ofType(MessageActions.receiveMessage.toString())
    .map(action => ({ messages: List.of(action.payload.message) }))

  const messageList$ = action$
    .ofType(MessageActions.receivePaginatedMessageList.toString(), MessageActions.receiveNextMessageList.toString())
    .map(action => action.payload)

  return Observable.merge(message$, messageList$)
    .map(({ messages }) => {
      const hrefsByMessageId = getHrefsByMessageId(getState())
      const hrefsByMessageIdToFetch = messages
        .filter(message => !hrefsByMessageId.has(message.id))
        .filter(message => typeof message.body === 'string')
        .filter(message => message.type === 'CHAT' || message.contentType === 'PRIVATE_NOTE' || message.type === 'PRIVATE_PROMPT' || message.type === 'EDIT')
        .reduce((result, message) => {
          if (message.getIn(['attributes', 'supportBotLinks'])) {
            return result
          }

          const parser = new DOMParser()
          const doc = parser.parseFromString(message.body, "text/html")

          const hrefs = []
          _forEach(doc.getElementsByTagName('a'), (link) => {
            if (link.href && link.href.startsWith('http')) {
              hrefs.push(link.href)
            }
          })

          return result.set(message.id, List(hrefs))
        }, Map())

      return updateHrefs(hrefsByMessageIdToFetch)
    })
}

function fetchCards(action$, { getState }) {
  return action$.ofType(updateHrefs.toString())
    .map(action => action.payload)
    .filter(payload => !payload.isEmpty())
    .mergeMap(hrefsByMessageId => {
      return hrefsByMessageId
        .valueSeq()
        .flatten()
        .filter((href) => !getCardsByHref(getState()).has(href))
        .toSet()
        .toJS()
    })
    .map(fetchCard)
}

function fetchCardEpic(action$) {
  return action$
    .ofType(FETCH_CARD)
    .mergeMap((action) => {
      const href = action.payload
      return cardApi.fetchCard(href)
        .map((card) => fetchCardSuccess({ href, card }))
        .catch((error) => Observable.of(fetchCardFailure({ href, error })))
    }, 1)
}

export default combineEpics(
  fetchCards,
  fetchCardEpic,
  extractLinks,
)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/cards/epic.js